import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { PROJECT_API } from "./apiRoutes";

interface UseGetPlanListByProjectIdProps {
  projectId: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getPlanListByProjectId = async (projectId: string) => {
  return await axiosAuth.get(`${PROJECT_API}/${projectId}/plans`);
};

const useGetPlanListByProjectId = ({
  projectId,
  queryParams
}: UseGetPlanListByProjectIdProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["plan-list", projectId],
    queryFn: () => getPlanListByProjectId(projectId),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
  });
};

export default useGetPlanListByProjectId;
